/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopItem', 'model/WorkshopItemCategory', 'model/WorkshopItemCategoryConnection', 'model/WorkshopItemRating', 'model/WorkshopPhaseComparisonAxis', 'model/WorkshopPhaseComparisonDimension', 'model/WorkshopPhaseGridBlock', 'model/WorkshopQuestionnaireFilter', 'model/WorkshopQuestionnaireQuestionReport', 'model/WorkshopRatingPhaseSourceReport', 'model/WorkshopResultPhaseSource', 'model/WorkshopWidgetIdeaGenerationTheme', 'model/WorkshopWidgetParticipantStatus'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./WorkshopItem'), require('./WorkshopItemCategory'), require('./WorkshopItemCategoryConnection'), require('./WorkshopItemRating'), require('./WorkshopPhaseComparisonAxis'), require('./WorkshopPhaseComparisonDimension'), require('./WorkshopPhaseGridBlock'), require('./WorkshopQuestionnaireFilter'), require('./WorkshopQuestionnaireQuestionReport'), require('./WorkshopRatingPhaseSourceReport'), require('./WorkshopResultPhaseSource'), require('./WorkshopWidgetIdeaGenerationTheme'), require('./WorkshopWidgetParticipantStatus'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopWidgetReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopItem, root.ForStractionServiceApi.WorkshopItemCategory, root.ForStractionServiceApi.WorkshopItemCategoryConnection, root.ForStractionServiceApi.WorkshopItemRating, root.ForStractionServiceApi.WorkshopPhaseComparisonAxis, root.ForStractionServiceApi.WorkshopPhaseComparisonDimension, root.ForStractionServiceApi.WorkshopPhaseGridBlock, root.ForStractionServiceApi.WorkshopQuestionnaireFilter, root.ForStractionServiceApi.WorkshopQuestionnaireQuestionReport, root.ForStractionServiceApi.WorkshopRatingPhaseSourceReport, root.ForStractionServiceApi.WorkshopResultPhaseSource, root.ForStractionServiceApi.WorkshopWidgetIdeaGenerationTheme, root.ForStractionServiceApi.WorkshopWidgetParticipantStatus);
  }
}(this, function(ApiClient, WorkshopItem, WorkshopItemCategory, WorkshopItemCategoryConnection, WorkshopItemRating, WorkshopPhaseComparisonAxis, WorkshopPhaseComparisonDimension, WorkshopPhaseGridBlock, WorkshopQuestionnaireFilter, WorkshopQuestionnaireQuestionReport, WorkshopRatingPhaseSourceReport, WorkshopResultPhaseSource, WorkshopWidgetIdeaGenerationTheme, WorkshopWidgetParticipantStatus) {
  'use strict';




  /**
   * The WorkshopWidgetReport model module.
   * @module model/WorkshopWidgetReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopWidgetReport</code>.
   * @alias module:model/WorkshopWidgetReport
   * @class
   */
  var exports = function() {
    var _this = this;
























































  };

  /**
   * Constructs a <code>WorkshopWidgetReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopWidgetReport} obj Optional instance to populate.
   * @return {module:model/WorkshopWidgetReport} The populated <code>WorkshopWidgetReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ParticipantStatuses')) {
        obj['ParticipantStatuses'] = ApiClient.convertToType(data['ParticipantStatuses'], [WorkshopWidgetParticipantStatus]);
      }
      if (data.hasOwnProperty('ItemCategories')) {
        obj['ItemCategories'] = ApiClient.convertToType(data['ItemCategories'], [WorkshopItemCategory]);
      }
      if (data.hasOwnProperty('ItemCategoryConnections')) {
        obj['ItemCategoryConnections'] = ApiClient.convertToType(data['ItemCategoryConnections'], [WorkshopItemCategoryConnection]);
      }
      if (data.hasOwnProperty('Items')) {
        obj['Items'] = ApiClient.convertToType(data['Items'], [WorkshopItem]);
      }
      if (data.hasOwnProperty('RatingPhaseSources')) {
        obj['RatingPhaseSources'] = ApiClient.convertToType(data['RatingPhaseSources'], [WorkshopRatingPhaseSourceReport]);
      }
      if (data.hasOwnProperty('ItemRatings')) {
        obj['ItemRatings'] = ApiClient.convertToType(data['ItemRatings'], [WorkshopItemRating]);
      }
      if (data.hasOwnProperty('GridBlocks')) {
        obj['GridBlocks'] = ApiClient.convertToType(data['GridBlocks'], [WorkshopPhaseGridBlock]);
      }
      if (data.hasOwnProperty('ComparisonAxes')) {
        obj['ComparisonAxes'] = ApiClient.convertToType(data['ComparisonAxes'], [WorkshopPhaseComparisonAxis]);
      }
      if (data.hasOwnProperty('ComparisonDimensions')) {
        obj['ComparisonDimensions'] = ApiClient.convertToType(data['ComparisonDimensions'], [WorkshopPhaseComparisonDimension]);
      }
      if (data.hasOwnProperty('QuestionnaireFilters')) {
        obj['QuestionnaireFilters'] = ApiClient.convertToType(data['QuestionnaireFilters'], [WorkshopQuestionnaireFilter]);
      }
      if (data.hasOwnProperty('QuestionnaireQuestions')) {
        obj['QuestionnaireQuestions'] = ApiClient.convertToType(data['QuestionnaireQuestions'], [WorkshopQuestionnaireQuestionReport]);
      }
      if (data.hasOwnProperty('ResultPhaseSources')) {
        obj['ResultPhaseSources'] = ApiClient.convertToType(data['ResultPhaseSources'], [WorkshopResultPhaseSource]);
      }
      if (data.hasOwnProperty('IdeaGenerationThemes')) {
        obj['IdeaGenerationThemes'] = ApiClient.convertToType(data['IdeaGenerationThemes'], [WorkshopWidgetIdeaGenerationTheme]);
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentRowID')) {
        obj['ContentRowID'] = ApiClient.convertToType(data['ContentRowID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('TemplateDefaultStatusID')) {
        obj['TemplateDefaultStatusID'] = ApiClient.convertToType(data['TemplateDefaultStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('RowPosition')) {
        obj['RowPosition'] = ApiClient.convertToType(data['RowPosition'], 'Integer');
      }
      if (data.hasOwnProperty('CategoryCreationRuleID')) {
        obj['CategoryCreationRuleID'] = ApiClient.convertToType(data['CategoryCreationRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('CategoryCreationWidgetID')) {
        obj['CategoryCreationWidgetID'] = ApiClient.convertToType(data['CategoryCreationWidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('ItemCategoryConversionLimit')) {
        obj['ItemCategoryConversionLimit'] = ApiClient.convertToType(data['ItemCategoryConversionLimit'], 'Integer');
      }
      if (data.hasOwnProperty('ItemCreationRuleID')) {
        obj['ItemCreationRuleID'] = ApiClient.convertToType(data['ItemCreationRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('FromCrossPollinationWidgetID')) {
        obj['FromCrossPollinationWidgetID'] = ApiClient.convertToType(data['FromCrossPollinationWidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('ToCrossPollinationWidgetID')) {
        obj['ToCrossPollinationWidgetID'] = ApiClient.convertToType(data['ToCrossPollinationWidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('MinimumIdentifiedItemsCount')) {
        obj['MinimumIdentifiedItemsCount'] = ApiClient.convertToType(data['MinimumIdentifiedItemsCount'], 'Integer');
      }
      if (data.hasOwnProperty('XAxisName')) {
        obj['XAxisName'] = ApiClient.convertToType(data['XAxisName'], 'String');
      }
      if (data.hasOwnProperty('YAxisName')) {
        obj['YAxisName'] = ApiClient.convertToType(data['YAxisName'], 'String');
      }
      if (data.hasOwnProperty('AxisStartPointExplanation')) {
        obj['AxisStartPointExplanation'] = ApiClient.convertToType(data['AxisStartPointExplanation'], 'String');
      }
      if (data.hasOwnProperty('AxisEndPointExplanation')) {
        obj['AxisEndPointExplanation'] = ApiClient.convertToType(data['AxisEndPointExplanation'], 'String');
      }
      if (data.hasOwnProperty('UseGridLayout')) {
        obj['UseGridLayout'] = ApiClient.convertToType(data['UseGridLayout'], 'Boolean');
      }
      if (data.hasOwnProperty('VotingTypeID')) {
        obj['VotingTypeID'] = ApiClient.convertToType(data['VotingTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomVoteCount')) {
        obj['CustomVoteCount'] = ApiClient.convertToType(data['CustomVoteCount'], 'Integer');
      }
      if (data.hasOwnProperty('DescendingRatedItemOrder')) {
        obj['DescendingRatedItemOrder'] = ApiClient.convertToType(data['DescendingRatedItemOrder'], 'Boolean');
      }
      if (data.hasOwnProperty('AllowPersonalItemRating')) {
        obj['AllowPersonalItemRating'] = ApiClient.convertToType(data['AllowPersonalItemRating'], 'Boolean');
      }
      if (data.hasOwnProperty('LastResultCalculationDate')) {
        obj['LastResultCalculationDate'] = ApiClient.convertToType(data['LastResultCalculationDate'], 'Date');
      }
      if (data.hasOwnProperty('AskTrackingLevel')) {
        obj['AskTrackingLevel'] = ApiClient.convertToType(data['AskTrackingLevel'], 'Boolean');
      }
      if (data.hasOwnProperty('TargetTrackingLevelID')) {
        obj['TargetTrackingLevelID'] = ApiClient.convertToType(data['TargetTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('AllowIndicatorImport')) {
        obj['AllowIndicatorImport'] = ApiClient.convertToType(data['AllowIndicatorImport'], 'Boolean');
      }
      if (data.hasOwnProperty('ResultPresentationTypeID')) {
        obj['ResultPresentationTypeID'] = ApiClient.convertToType(data['ResultPresentationTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalContentUrl')) {
        obj['ExternalContentUrl'] = ApiClient.convertToType(data['ExternalContentUrl'], 'String');
      }
      if (data.hasOwnProperty('EmbedExternalContent')) {
        obj['EmbedExternalContent'] = ApiClient.convertToType(data['EmbedExternalContent'], 'Boolean');
      }
      if (data.hasOwnProperty('ExternalContentTypeID')) {
        obj['ExternalContentTypeID'] = ApiClient.convertToType(data['ExternalContentTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalContentMimeType')) {
        obj['ExternalContentMimeType'] = ApiClient.convertToType(data['ExternalContentMimeType'], 'String');
      }
      if (data.hasOwnProperty('ExternalContentPreviewImageUrl')) {
        obj['ExternalContentPreviewImageUrl'] = ApiClient.convertToType(data['ExternalContentPreviewImageUrl'], 'String');
      }
      if (data.hasOwnProperty('IdeaGenerationIntro')) {
        obj['IdeaGenerationIntro'] = ApiClient.convertToType(data['IdeaGenerationIntro'], 'String');
      }
      if (data.hasOwnProperty('IdeaGenerationPrompt')) {
        obj['IdeaGenerationPrompt'] = ApiClient.convertToType(data['IdeaGenerationPrompt'], 'String');
      }
      if (data.hasOwnProperty('DefaultExportStrategyID')) {
        obj['DefaultExportStrategyID'] = ApiClient.convertToType(data['DefaultExportStrategyID'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultExportGoalID')) {
        obj['DefaultExportGoalID'] = ApiClient.convertToType(data['DefaultExportGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultExportMilestoneID')) {
        obj['DefaultExportMilestoneID'] = ApiClient.convertToType(data['DefaultExportMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultExportProgramID')) {
        obj['DefaultExportProgramID'] = ApiClient.convertToType(data['DefaultExportProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/WorkshopWidgetParticipantStatus>} ParticipantStatuses
   */
  exports.prototype['ParticipantStatuses'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopItemCategory>} ItemCategories
   */
  exports.prototype['ItemCategories'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopItemCategoryConnection>} ItemCategoryConnections
   */
  exports.prototype['ItemCategoryConnections'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopItem>} Items
   */
  exports.prototype['Items'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopRatingPhaseSourceReport>} RatingPhaseSources
   */
  exports.prototype['RatingPhaseSources'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopItemRating>} ItemRatings
   */
  exports.prototype['ItemRatings'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopPhaseGridBlock>} GridBlocks
   */
  exports.prototype['GridBlocks'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopPhaseComparisonAxis>} ComparisonAxes
   */
  exports.prototype['ComparisonAxes'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopPhaseComparisonDimension>} ComparisonDimensions
   */
  exports.prototype['ComparisonDimensions'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopQuestionnaireFilter>} QuestionnaireFilters
   */
  exports.prototype['QuestionnaireFilters'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopQuestionnaireQuestionReport>} QuestionnaireQuestions
   */
  exports.prototype['QuestionnaireQuestions'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopResultPhaseSource>} ResultPhaseSources
   */
  exports.prototype['ResultPhaseSources'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopWidgetIdeaGenerationTheme>} IdeaGenerationThemes
   */
  exports.prototype['IdeaGenerationThemes'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Integer} ContentRowID
   * @default 0
   */
  exports.prototype['ContentRowID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} StatusID
   */
  exports.prototype['StatusID'] = undefined;
  /**
   * @member {Integer} TemplateDefaultStatusID
   */
  exports.prototype['TemplateDefaultStatusID'] = undefined;
  /**
   * @member {Integer} RowPosition
   * @default 0
   */
  exports.prototype['RowPosition'] = 0;
  /**
   * @member {Integer} CategoryCreationRuleID
   */
  exports.prototype['CategoryCreationRuleID'] = undefined;
  /**
   * @member {Integer} CategoryCreationWidgetID
   */
  exports.prototype['CategoryCreationWidgetID'] = undefined;
  /**
   * @member {Integer} ItemCategoryConversionLimit
   */
  exports.prototype['ItemCategoryConversionLimit'] = undefined;
  /**
   * @member {Integer} ItemCreationRuleID
   */
  exports.prototype['ItemCreationRuleID'] = undefined;
  /**
   * @member {Integer} FromCrossPollinationWidgetID
   */
  exports.prototype['FromCrossPollinationWidgetID'] = undefined;
  /**
   * @member {Integer} ToCrossPollinationWidgetID
   */
  exports.prototype['ToCrossPollinationWidgetID'] = undefined;
  /**
   * @member {Integer} MinimumIdentifiedItemsCount
   */
  exports.prototype['MinimumIdentifiedItemsCount'] = undefined;
  /**
   * @member {String} XAxisName
   * @default ''
   */
  exports.prototype['XAxisName'] = '';
  /**
   * @member {String} YAxisName
   * @default ''
   */
  exports.prototype['YAxisName'] = '';
  /**
   * @member {String} AxisStartPointExplanation
   * @default ''
   */
  exports.prototype['AxisStartPointExplanation'] = '';
  /**
   * @member {String} AxisEndPointExplanation
   * @default ''
   */
  exports.prototype['AxisEndPointExplanation'] = '';
  /**
   * @member {Boolean} UseGridLayout
   * @default false
   */
  exports.prototype['UseGridLayout'] = false;
  /**
   * @member {Integer} VotingTypeID
   */
  exports.prototype['VotingTypeID'] = undefined;
  /**
   * @member {Integer} CustomVoteCount
   */
  exports.prototype['CustomVoteCount'] = undefined;
  /**
   * @member {Boolean} DescendingRatedItemOrder
   * @default false
   */
  exports.prototype['DescendingRatedItemOrder'] = false;
  /**
   * @member {Boolean} AllowPersonalItemRating
   * @default false
   */
  exports.prototype['AllowPersonalItemRating'] = false;
  /**
   * @member {Date} LastResultCalculationDate
   */
  exports.prototype['LastResultCalculationDate'] = undefined;
  /**
   * @member {Boolean} AskTrackingLevel
   * @default false
   */
  exports.prototype['AskTrackingLevel'] = false;
  /**
   * @member {Integer} TargetTrackingLevelID
   */
  exports.prototype['TargetTrackingLevelID'] = undefined;
  /**
   * @member {Boolean} AllowIndicatorImport
   * @default false
   */
  exports.prototype['AllowIndicatorImport'] = false;
  /**
   * @member {Integer} ResultPresentationTypeID
   */
  exports.prototype['ResultPresentationTypeID'] = undefined;
  /**
   * @member {String} ExternalContentUrl
   * @default ''
   */
  exports.prototype['ExternalContentUrl'] = '';
  /**
   * @member {Boolean} EmbedExternalContent
   * @default false
   */
  exports.prototype['EmbedExternalContent'] = false;
  /**
   * @member {Integer} ExternalContentTypeID
   */
  exports.prototype['ExternalContentTypeID'] = undefined;
  /**
   * @member {String} ExternalContentMimeType
   * @default ''
   */
  exports.prototype['ExternalContentMimeType'] = '';
  /**
   * @member {String} ExternalContentPreviewImageUrl
   * @default ''
   */
  exports.prototype['ExternalContentPreviewImageUrl'] = '';
  /**
   * @member {String} IdeaGenerationIntro
   * @default ''
   */
  exports.prototype['IdeaGenerationIntro'] = '';
  /**
   * @member {String} IdeaGenerationPrompt
   * @default ''
   */
  exports.prototype['IdeaGenerationPrompt'] = '';
  /**
   * @member {Integer} DefaultExportStrategyID
   */
  exports.prototype['DefaultExportStrategyID'] = undefined;
  /**
   * @member {Integer} DefaultExportGoalID
   */
  exports.prototype['DefaultExportGoalID'] = undefined;
  /**
   * @member {Integer} DefaultExportMilestoneID
   */
  exports.prototype['DefaultExportMilestoneID'] = undefined;
  /**
   * @member {Integer} DefaultExportProgramID
   */
  exports.prototype['DefaultExportProgramID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


